import logo from './logo.svg';
import './App.css';
import { Routes, Route } from "react-router-dom"
import {Link} from 'react-router-dom';
import {useEffect, useState, useRef, setState} from "react";

function GridItem({title, img, slug, mouseX, mouseY, year}){
    const ref = useRef(null);
    const [isHover, setHover] = useState(false);
    const [offset, setOffset] = useState([]);
    useEffect(()=> {
        if(isHover) {
            setOffset([ref.current.offsetTop, ref.current.offsetLeft]);
        } else {
            setOffset([ref.current.offsetTop, ref.current.offsetLeft]);
        }
    }, [isHover]);
    const inlineStyle = {
        transform: `perspective(800px) rotateY(${(mouseX-offset[0])/30}deg) rotateX(${(mouseY-offset[1])/30}deg)`
    }
    return(
            <div ref={ref} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} className="item">
            <Link to={"/work/"+slug}>
              <img src={img} style={inlineStyle} />
            <div className='thumb' style={{backgroundImage: `url(${img})`}} />
            <div className="title">
            {title} ({year})
            </div>
            </Link>
            </div>      
    )
}
export default GridItem;